import { IconWrapper } from "@insite/mobius/Icon";
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@guestsupply/XDL/Icons/Close";
import { buttonTransparent } from "@guestsupply/XDL/PreStyle/button";
import { xBaseTheme } from "@guestsupply/XDL/types";
import { color, getSystemColor } from "@guestsupply/XDL/Utilities";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        color: "primary",
        typographyProps: {
            size: 10,
            weight: "bold",
            color: getSystemColor("common.ui1"),
            ellipsis: true,
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: 11px;
            `,
        },
        iconProps: {
            size: 10,
            src: Close,
            color: "common.ui1",
            css: css`
                &&& {
                    &:hover {
                        color: ${color("common.ui8")};
                    }
                    svg {
                        height: 10px;
                        width: 7px;
                    }
                }
            `,
        },
        css: css`
            min-height: 26px;
            border-radius: 35px;
            flex-direction: row;
            align-items: center;
            padding: 8px;
            margin: 0 4px 4px 0;
            button {
                margin-right: 8px;
                height: 12px;
                ${buttonTransparent}
            }
        `,
    },
} as xBaseTheme["tag"];
